export const auth_routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../Main.vue")
  },
  {
    path: "/excluir-conta",
    name: "Exclusão de conta",
    component: () => import("../DeleteAccount.vue")
  },
  {
    path: "/politica-de-privacidade",
    name: "Política de Privacidade",
    component: () => import("../PrivacyPolicy.vue")
  },
  {
    path: "/suporte",
    name: "Suporte",
    component: () => import("../Support.vue")
  },
  {
    path: "/recover-pass/:token",
    props: true,
    name: "Recuperação de Senha",
    component: () => import("../ForgotPasswordFire.vue")
  },
  {
    path: "/activate-account/:id",
    props: true,
    name: "Ative sua conta",
    component: () => import("../ActivateAccount.vue")
  },
  {
    path: "/:sponsor_id",
    props: true,
    name: "Cadastro",
    component: () => import("../components/FormSignup")
  }
];

export default {};
